const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-clustermanager/shared/adapters/GoogleMapPointAdapter");